import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IAccountUpgradeToEnterpriseData } from './interfaces';
import { showErrorMessage, showSuccessMessage } from '../../notifications';

export const UPGRADE_ACCOUNT_TO_ENTERPRISE_THUNK_PREFIX = 'account/upgradeToEnterprise';
export const upgradeAccountToEnterprise: AsyncThunk<void, IAccountUpgradeToEnterpriseData, ThunkAPI> =
  createAsyncThunk(
    UPGRADE_ACCOUNT_TO_ENTERPRISE_THUNK_PREFIX,
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.Plgupgrade)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        if(!isFeatureEnabled(Features.BillingUserFacing)) {
          delete data.carbonCopyRecipients;
        }
        const response = await basicApiAsyncThunkCreator<void, IAccountUpgradeToEnterpriseData>({
          endpoint: 'accounts/upgrade-to-enterprise/upgrade-account',
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })(data, thunk);
        thunk.dispatch(showSuccessMessage('Account has been upgraded'));
        return response;
      } catch (err) {
        thunk.dispatch(showErrorMessage(JSON.stringify(err)));
        return thunk.rejectWithValue(err);
      }
    }
  );
